/**
 * <cart-offer-link>
 * Wraps the cart drawer's "Pick your second tee" link. On a page with the Make it two row
 * (#make-it-two, product pages), it closes the drawer and scrolls to that row instead of leaving
 * the page. Everywhere else the link works normally and goes to All Tees.
 */
class CartOfferLink extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('[data-make-it-two-link]')) return;
      const target = document.getElementById('make-it-two');
      if (!target) return;

      event.preventDefault();
      this.closest('dialog')?.close();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        target.querySelector('[data-make-it-two-heading]')?.focus({ preventScroll: true });
      });
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('cart-offer-link')) {
  customElements.define('cart-offer-link', CartOfferLink);
}
